import { StepBasedForm, SuccessPage } from '@components'

import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSkatConnection } from '@features/vatDeclarations/contexts/skatConnectionContext'
import { IntegrationFormFlow } from '@features/vatDeclarations/enums/integrationFormFlow'
import { SkatIntegrationStatus } from '@features/vatDeclarations/enums/skatIntegrationStatus'

import { useSegment } from '../../../../hooks'
import { InstructionsPage } from './elements/InstructionsPage'

const stepStatus = {
  [SkatIntegrationStatus.Idle]: '1 - How to',
  [SkatIntegrationStatus.Redirecting]: '2 - Redirecting',
  [SkatIntegrationStatus.Connecting]: '3 - Disconnecting',
}

export const SkatDisconnectionView = () => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { connectionState, isSkatConnected, setConnectionState, setSkatShowDisconnectionView } = useSkatConnection()

  const handleCloseForm = useCallback(() => {
    setConnectionState(SkatIntegrationStatus.Idle)
    setSkatShowDisconnectionView(false)
  }, [setConnectionState, setSkatShowDisconnectionView])

  const handleCancelClick = useCallback(() => {
    handleCloseForm()
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Disconnect,
      step: stepStatus[connectionState],
      buttonClick: 'Cancel',
    })
  }, [connectionState, handleCloseForm, track])

  const handleBackClick = useCallback(() => {
    handleCloseForm()
    track('xxx - Bookkeeping - DK VAT integration', {
      buttonClick: 'Back',
      flow: IntegrationFormFlow.Disconnect,
      step: isSkatConnected ? stepStatus[connectionState] : '4 - Success',
    })
  }, [connectionState, handleCloseForm, isSkatConnected, track])

  const handleDoneClick = useCallback(() => {
    handleCloseForm()
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Disconnect,
      step: '4 - Success',
      buttonClick: 'Done',
    })
  }, [handleCloseForm, track])

  return (
    <StepBasedForm onBack={handleBackClick}>
      {isSkatConnected ? (
        <InstructionsPage handleCancelClick={handleCancelClick} />
      ) : (
        <SuccessPage
          onDoneClick={handleDoneClick}
          headerLabel={t('skat_form.disconnect.success_header')}
          bodyLabel={t('skat_form.disconnect.success_body')}
        />
      )}
    </StepBasedForm>
  )
}
